/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

export const leasesKeys = {
  /** Every lease query for one agency -- the prefix a create invalidates. */
  all: (agencyId: string) => ['leases', agencyId] as const,
  list: (agencyId: string, state: string) => ['leases', agencyId, 'list', state] as const,
  detail: (agencyId: string, leaseId: string) => ['leases', agencyId, 'detail', leaseId] as const,
  expectations: (agencyId: string, leaseId: string) =>
    ['leases', agencyId, 'expectations', leaseId] as const,
  documents: (agencyId: string, leaseId: string) =>
    ['leases', agencyId, 'documents', leaseId] as const,
  settings: (agencyId: string) => ['leases', agencyId, 'settings'] as const,
};
